import { render, staticRenderFns } from "./IconPoiDaycare.vue?vue&type=template&id=46c12a14&"
import script from "./IconPoiDaycare.vue?vue&type=script&lang=js&"
export * from "./IconPoiDaycare.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports